module.exports = __webpack_public_path__ + "static/media/trellis-texts.a8119334.png";